import theme from "../utils/styles";

export const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const randomColors = (length) => {
  const { colors } = theme;

  let listOfColors = ["orange", "blue", "pink", "indigo", "green"];

  listOfColors.forEach(
    (colorName, index) => (listOfColors[index] = colors[colorName])
  );

  let output = Array.from({ length });

  output = output.map(
    (item) => listOfColors[randomIntFromInterval(0, listOfColors.length - 1)]
  );

  return output;
};
